const globalStyles = {
  colors: {
    dark: {
      main: "#012d35",
      secondary: "#00a051",
      accent: "#ffffff",
    },
    light: {
      main: "#f2f2f2",
      secondary: "#282827",
      accent: "#53d6c5",
    },
    headsets: {
      green: "#6a994e",
      red: "#d62828",
      yellow: "#ffca3a",
      blue: "#0077b6",
      white: "#f2f2f2",
    },
  },
}

export default globalStyles
